import Autocomplete from '../era/Autocomplete';
import React from 'react'

// Variation of Autocomplete with "Select ${label}" placeholder and fullWidth defaults
const AltAutocomplete = ({ label, placeholder, options, value, onChange, ...props }) => {
  const newPlaceholder = placeholder || (label ? `Select ${label}` : '');

  // Default equality test that handles empty string values gracefully
  const isOptionEqualToValue = (option, val) => {
    // If the value is an empty string or null, consider it a non-match
    if (val === '' || val === null || val === undefined) {
      return false;
    }
    // Otherwise, perform a standard comparison
    return option === val;
  };

  // Handle change events properly
  const handleChange = (event, newValue) => {
    if (onChange) {
      onChange(event, newValue);
    }
  };

  return (
    <Autocomplete
      fullWidth
      label={label}
      placeholder={newPlaceholder}
      options={options}
      value={value || null} // Pass null instead of '' to Autocomplete for "no value"
      isOptionEqualToValue={isOptionEqualToValue}
      onChange={handleChange}
      {...props}
    />
  );
};

export default AltAutocomplete;
